"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundNode = void 0;
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ROUND';
class RoundNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            var _a, _b;
            const inputNumber = params.inputNum !== null ? Number(params.inputNum) : NaN;
            const digitToRound = params.roundDigit !== null ? Number(params.roundDigit) : NaN;
            if (isNaN(inputNumber) || isNaN(digitToRound)) {
                return { result: undefined };
            }
            else if (gen5_shared_utilities_1.mod(digitToRound, 1) !== 0) {
                return { result: undefined };
            }
            else if (digitToRound <= 0) {
                const result = (_a = Number(inputNumber.toFixed(-digitToRound))) !== null && _a !== void 0 ? _a : undefined;
                return { result };
            }
            const power = Math.pow(10, digitToRound);
            const result = (_b = Math.round(inputNumber / power) * power) !== null && _b !== void 0 ? _b : undefined;
            return { result };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.RoundNode = RoundNode;
RoundNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Round',
    isIdempotent: true,
    primaryCategory: 'Math',
};
//# sourceMappingURL=Round.js.map